import vendor from './vendor'

export default {
  vendor
}
